const resource = '/admin/v1/contacts/memos';

export default $axios => ({  
  store(payload) {
    return $axios.post(`${resource}`, payload);
  },
  deleteMultiple(ids) {
    return $axios.post(`${resource}/delete-multiple`, ids);
  },
});